<template>
    <div>
        <!--PAGE HEADER-->
            <app-page-header :areaTitle="departmentName" :menuItem="menuItem" />

        <!--ORDERS TOTAL-->
            <div class="lead border border-top-0 border-left-0 border-right-0 border-bottom text-left text-info">
                Orders: 
                
                    <a href="#" class="text-danger" @click="CurrentOrderView = false; tableView = false">
                        {{ ordersOpenTotal }} new
                    </a> 
                
                of 
                    <a href="#" class="text-success" @click="CurrentOrderView = false; tableView = true">
                        {{ ordersAllTotal }} in total
                    </a>
                
            </div>        

        <!--CURRENT ORDER VIEW -->
            <div v-if="CurrentOrderView">
                <div class="text-right mt-4">
                    <small>
                        <a href="#" class="text-warning"
                                @click="CurrentOrderView=false; tableView = !tableView">
                                    {{ !tableView ? 'Show All Orders' : 'Show Open Orders'}}
                        </a>
                    </small>
            </div>
            <!--ORDER DETAILS-->
                    <div class="card mt-3 mb-4" v-for="order in orderCurrent" :key="order.id">
                        <div class="card-header bg-muted text-left pt-4 pb-2">
                            <div class="row justify-content-center">
                                <div class="col-md-8 text-dark">
                                    <h3 class="text-info">Order {{ order.id }} Details</h3>
                                    <hr>
                                    <div class="row">
                                        <div class="col-sm-2">
                                            <small class="text-muted">Order Date:</small>
                                        </div>
                                        <div class="col-sm-5">
                                            <small>{{ order.order_date }}</small>
                                        </div>
                                    </div>
                                    <div class="row" v-if="order.order_last_mod_date">
                                        <div class="col-sm-2">
                                            <small class="text-muted">Last modified:</small>
                                        </div>
                                        <div class="col-sm-5" v-if="order.order_last_mod_date">
                                            <small>{{ order.order_last_mod_date }}</small>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-4 text-left text-dark">
                                    <h3 v-if="order.came_from != ''" class="text-center">
                                        <strong>
                                            <span class="text-success">{{order.came_from}}</span> 
                                            <span class="text-info">{{order.tile_size}}</span>
                                        </strong>
                                    </h3>
                                    <h3 v-else class="text-dark">Unknown Location</h3>
                                        <hr>
                                    <select class="form-control "
                                            :class="order.status==0 ? 'text-danger' : 'text-success'"
                                            id="order-status"
                                            @change="changeStatus($event, order.id)"
                                            v-model="order.status">
                                        <option value="0" class="text-danger">Open</option>
                                        <option value="1" class="text-success">Done</option>
                                    </select>
                                </div>
                            </div>
                        </div>
            <!--PERSONAL INFO-->
                    <div class="card-body">
                        <div class="my-4 text-left">
                            <p class="lead text-dark">Personal info:</p>
                                <div class="row">
                                    <div class="col-md">
                                        <table class="table table-striped">
                                            <tr>
                                                <td><small class="text-muted">E-mail:</small></td>
                                                <td>{{ order.email }}</td>
                                            </tr>
                                            <tr>
                                                <td><small class="text-muted">Animal:</small></td>
                                                <td>{{ order.animal_type }}</td>
                                            </tr>
                                            <tr>
                                                <td><small class="text-muted">Gallary Pix:</small></td>
                                                <td>{{ order.gallery_name }}</td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="col-md">
                                        <div class="card">
                                            <div class="card-body">
                                                <p><small class="text-muted">Message:</small></p>
                                                <p class="text-justify">{{ order.description }}</p>
                                            </div>
                                        </div>                                       
                                    </div>
                                </div>
                        </div>
                    <hr>
            <!--FONTS TEXT-->
                        <div class="my-4 text-left">
                            <p class="lead text-dark">Texts / Fonts / Layout / Ornaments:</p>
                                <div class="row">
                                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12">
                                        <table class="table table-light table-striped table-hover">
                                            <tr>
                                                <td style="width:15%"><small class="text-muted">Animal In Memory</small> </td>
                                                <td style="width:30%"><small class="text-muted">Font:</small> <span>{{ order.animal_memo_font }}</span></td>
                                                <td style="width:55%"><small class="text-muted">Text:</small> <span>{{ order.animal_memo }}</span></td>
                                            </tr>
                                            <tr>
                                                <td><small class="text-muted">Animal Name</small> </td>
                                                <td><small class="text-muted">Font:</small> <span>{{ order.animal_name_font }}</span></td>
                                                <td><small class="text-muted">Text:</small> <span>{{ order.animal_name }}</span></td>
                                            </tr>
                                            <tr>
                                                <td><small class="text-muted">Animal Dates</small> </td>
                                                <td><small class="text-muted">Font:</small> <span>{{ order.animal_dates_font }}</span></td>
                                                <td><small class="text-muted">Text:</small> <span>{{ order.animal_dates }}</span></td>
                                            </tr>
                                            <tr>
                                                <td><small class="text-muted">Text On Monument</small></td>
                                                <td><small class="text-muted">Font:</small> <span>{{ order.animal_text_font }}</span></td>                                                
                                                <td colspan="3"><small class="text-muted">Text:</small> <span>{{ order.animal_text }}</span></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
            <!--LAYOUTS-->
                                <div class="row my-4">
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <div class="row">
                                        <div class="col-md">
                                            <div class="card">
                                                <div class="card-header text-center text-info">Layout</div>
                                                <div class="card-body">
                                                    <div class="card-text">
                                                        <img class="img-fluid rounded" :src="'/static/img/layouts/' + order.layout" alt="Layout" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md">
                                            <div class="card">
                                                <div class="card-header text-center text-info">Ornaments</div>
                                                <div class="card-body">
                                                    <div class="card-text">
                                                        {{ order.ornaments }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
            <!--SILHOUETTES-->
                                <div class="col-md" v-if="order.selected_dog != null && order.selected_dog != 'null'">
                                    <div class="card">
                                        <div class="card-header text-center text-info">Dog Silhouette</div>
                                        <div class="card-body">
                                            <div class="card-text text-center">
                                                <img class="img-fluid rounded" :src="'/static/img/dogs/' + order.selected_dog" alt=" selected dog" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md" v-if="order.selected_cat != null && order.selected_cat != 'null'">
                                    <div class="card">
                                        <div class="card-header text-center text-info">Cat Silhouette</div>
                                        <div class="card-body">
                                            <div class="card-text text-center">
                                                <img class="img-fluid rounded" :src="'/static/img/cats/' + order.selected_cat" alt=" selected cat" />
                                            </div>
                                        </div>
                                    </div>
                                </div>                                        
                            </div>
                        </div>
                    </div>
                </div>
            <!--UPLOADS-->
                        <div class="my-4" v-if="order.upload_files">
                            <p class="lead text-dark text-left">Uploaded user pictures</p>
                            <div class="card">
                                <div class="card-body">
                                    <div class="text-left text-muted"> <small>Uploaded User Files Storage Location:</small> 
                                        <p class="text-info">/static/img/uploads/{{order.gallery_name}}/{{order.upload_files}}</p>
                                    </div> 
                                    <div class="row">
                                        <!--ЛОКАЛЬНЫЕ ИМИДЖИ 
                                            <div class="col-md" v-for="(img, index) in imgBuilder(order.gallaryName, order.uploadFiles)" :key="index">
                                            <div v-html="img"></div>
                                        </div> -->
                                        <app-lbox :images="imgBuilder(order.gallery_name, order.upload_files)" ></app-lbox>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="my-3">
                            <div class="row">
                                <!--COMPLITION DATE  
                                    <div class="col-md-6 text-left">
                                    <p class="lead text-dark">Desired complition date:</p>
                                    <p class="lead text-danger" v-if="order.dateComplition != 'null'">{{ order.dateComplition }}</p>
                                    <p class="lead text-success" v-else>Не важно</p>
                                    <br>
                                </div> -->
                                <div class="col-md-6 text-left">
                                    <p class="lead text-dark">Using pic in portfolio:
                                    <span class="lead text-success" v-if="order.using_pix_in_portfolio">YES</span>
                                    <span v-else class="lead text-danger">NO</span></p>
                                </div>
                            </div>
                        </div>
                        <div class="my-3 text-left" v-if="order.order_memo">
                            <p class="lead text-dark">Order notes:</p>
                            <div v-html="order.order_memo"></div>
                        </div>
                    </div>
                </div>
            </div>
        
        <!--OPEN ORDERS CARD VIEW-->
            <div v-else>        
            <!--HEADER-->
                <div class="text-right mt-4"><small><a href="#" class="text-warning" @click="tableView = !tableView">{{ !tableView ? 'Show All Orders' : 'Show Open Orders'}}</a></small></div>

            <div v-if="!tableView">
                <div class="card mt-3 mb-4" v-for="order in ordersOpen" :key="order.id">
                <div class="card-header bg-muted text-left pt-4 pb-2">
                    <div class="row justify-content-center">
                        <div class="col-md-8 text-dark">
                            <h2 class="text-danger">New Order: {{ order.id }}</h2>
                            <p class="mb-4"><small>Order Date: {{ order.order_date }}</small></p>
                        </div>
                        <div class="col-md-4 text-left text-dark">
                                <h3 v-if="order.came_from != ''" class="text-center">
                                    <strong><span class="text-success">{{order.came_from}}</span> 
                                        <span class="text-info">{{order.tile_size}}</span>
                                    </strong>
                                </h3>
                            <h3 v-else class="text-dark">Unknown Location</h3>                            
                            <select class="form-control "
                                    :class="order.status==0 ? 'text-danger' : 'text-success'"
                                    id="order-status"
                                    @change="changeStatus($event, order.id)"
                                    v-model="order.status">
                                <option value="0" class="text-danger">Open</option>
                                <option value="1" class="text-success">Done</option>
                            </select>
                        </div>
                    </div>
                </div>
            <!--PERSONAL INFO-->
                <div class="card-body">                    
                    <div class="my-4 text-left">
                        <p class="lead text-dark">Personal info:</p>
                            <div class="row">
                                <div class="col-md">
                                    <table class="table table-responsive table-striped">
                                        <tr>
                                            <td><small class="text-muted">E-mail:</small></td>
                                            <td>{{ order.email }}</td>
                                        </tr>
                                        <tr>
                                            <td><small class="text-muted">Animal:</small></td>
                                            <td>{{ order.animal_type }}</td>
                                        </tr>
                                        <tr>
                                            <td><small class="text-muted">Gallary Pix:</small></td>
                                            <td>{{ order.gallery_name }}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md">
                                    <div class="card">
                                        <div class="card-body">
                                            <p><small class="text-muted">Message:</small></p>
                                            <p class="text-justify">{{ order.description }}</p>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                        <hr>
            <!--TEXT FONTS LAYOUTS-->
                    <div class="my-4 text-left">
                        <p class="lead text-dark">Texts / Fonts / Layout / Ornaments:</p>
                            <div class="row">
                                <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12">
                                    <table class="table table-responsive table-light table-striped table-hover">
                                        <tr>
                                            <td style="width:15%"><small class="text-muted">Animal In Memory</small> </td>
                                            <td style="width:30%"><small class="text-muted">Font:</small> <span>{{ order.animal_memo_font }}</span></td>
                                            <td style="width:55%"><small class="text-muted">Text:</small> <span>{{ order.animal_memo }}</span></td>
                                        </tr>
                                        <tr>
                                            <td><small class="text-muted">Animal Name</small> </td>
                                            <td><small class="text-muted">Font:</small> <span>{{ order.animal_name_font }}</span></td>
                                            <td><small class="text-muted">Text:</small> <span>{{ order.animal_name }}</span></td>
                                        </tr>
                                        <tr>
                                            <td><small class="text-muted">Animal Dates</small> </td>
                                            <td><small class="text-muted">Font:</small> <span>{{ order.animal_dates_font }}</span></td>
                                            <td><small class="text-muted">Text:</small> <span>{{ order.animal_dates }}</span></td>
                                        </tr>
                                        <tr>
                                            <td><small class="text-muted">Text On Monument</small></td>
                                            <td><small class="text-muted">Font:</small> <span>{{ order.animal_text_font }}</span></td>                                                
                                            <td colspan="3"><small class="text-muted">Text:</small> <span>{{ order.animal_text }}</span></td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="row my-4">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <div class="row">
                                        <div class="col-md">
                                            <div class="card">
                                                <div class="card-header text-center text-dark">Layout</div>
                                                <div class="card-body">
                                                    <div class="card-text">
                                                        <img class="img-fluid rounded" :src="'/static/img/layouts/' + order.layout" alt="Layout" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md">
                                            <div class="card">
                                                <div class="card-header text-center text-dark">Ornaments</div>
                                                <div class="card-body">
                                                    <div class="card-text">
                                                        {{ order.ornaments }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
            <!--SILHOUETTES-->
                                <div class="col-md" v-if="order.selected_dog != null && order.selected_dog != 'null'">
                                    <div class="card">
                                        <div class="card-header text-center text-dark">Dog Silhouette</div>
                                        <div class="card-body">
                                            <div class="card-text text-center">
                                                <img class="img-fluid rounded" :src="'/static/img/dogs/' + order.selected_dog" alt=" selected dog" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md" v-if="order.selected_cat != null && order.selected_cat != 'null'">
                                    <div class="card">
                                        <div class="card-header text-center text-dark">Cat Silhouette</div>
                                        <div class="card-body">
                                            <div class="card-text text-center">
                                                <img class="img-fluid rounded" :src="'/static/img/cats/' + order.selected_cat" alt=" selected cat" />
                                            </div>
                                        </div>
                                    </div>
                                </div>                                        
                            </div>
                        </div>
                    </div>
                </div>
            <!--UPLEADED PIXS-->
                    <div class="my-4"  v-if="order.upload_files">
                        <p class="lead text-dark text-left">Uploaded user pictures</p>
                        <div class="card">
                            <div class="card-body">
                                <div class="text-left text-muted"> <small>Uploaded User Files Storage Location:</small> 
                                    <p class="text-info">/static/img/uploads/{{order.gallery_name}}/{{order.upload_files}}</p>
                                </div> 
                                <div class="row">
                                <!--ТРАНСЛИРУЕТ КАРТИНКИ БЕЗ ЛАЙТБОКСА, НАПРЯМУЮ НА СТРАНИЦУ
                                    <div class="col-md" v-for="(img, index) in imgBuilder(order.gallaryName, order.uploadFiles)" :key="index">
                                        <div v-html="img"></div>
                                    </div>-->
                                    <app-lbox v-if="order.gallaryName != null" :images="imgBuilder(order.gallery_name, order.upload_files)" ></app-lbox>
                                </div> 
                            </div>
                        </div>
                    </div>
            <!--USING PICTURE IN PORTFOLIO-->
                        <div class="my-3">
                            <div class="row">
                            <!--<div class="col-md-6 text-left">
                                    <p class="lead text-warning">Desired complition date:</p>
                                    <p class="lead text-danger" v-if="order.dateComplition != 'null'">{{ order.dateComplition }}</p>
                                    <p class="lead text-success" v-else>Не важно</p>
                                    <br>
                                </div>-->
                                <div class="col-md-6 text-left">
                                    <p class="lead text-dark">Using pic in portfolio:
                                    <span class="lead text-success" v-if="order.using_pix_in_portfolio">YES</span>
                                    <span v-else class="lead text-danger">NO</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <!--ALL ORDERS TABLE VIEW-->
            <transition name="fade">
                <div class="mt-3" v-if="tableView">
                    <table class="table table-responsive table-bordered table-light table-striped table-hover" style="width: 100%">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <td><i class="fas fa-glasses"></i></td>
                                <th><i class="fas fa-edit"></i></th>
                                <th><i class="fas fa-trash-alt"></i></th> 
                                <th>Status</th>                                               
                                <th>Date</th>
                            <!--<th>Modify</th>
                                <th>Status</th>
                                <th>Pix Dir</th>-->
                                <th>Email</th>
                            <!--<th>Description</th>-->
                                <th>Animal</th>
                                <th>From</th>
                                <th>Size</th>                        
                            <!--<th>Name</th>
                                <th>NFont</th>
                                <th>Dates</th>
                                <th>DFont</th>
                                <th>Text</th>
                                <th>TFont</th>
                                <th>Layout</th>
                                <th>Complition</th>
                                <th>Ornaments</th>-->
                                <th>Pic?</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="align-text-middle" v-for="order in orders" :key="order.id">
                                <td class="align-middle">{{ order.id }}</td>
                                <td class="align-middle"><a href="#" class="btn" @click.prevent="getCurrentOrder(order.id)"><i class="fas fa-glasses"></i></a></td>
                                <td class="align-middle"><a href="#" class="btn" @click.prevent="editOrder(order.id)"><i class="fas fa-edit"></i></a></td>
                                <td class="align-middle"><a href="#" class="btn" @click.prevent="deleteOrder(order.id)"><i class="fas fa-trash-alt"></i></a></td>                        
                                <td>
                                    <select class="form-control"
                                        :class="order.status==0 ? 'text-danger' : 'text-success'"
                                            id="order-status"
                                            @change="changeStatus($event, order.id)"
                                            v-model="order.status">
                                        <option value="0" class="text-danger">Open</option>
                                        <option value="1" class="text-success">Closed</option>
                                    </select>
                                </td>
                                <td class="align-middle">{{ order.order_date }}</td>
                            <!--<td class="align-middle">{{ order.orderLastModDate }}</td>
                                <td class="align-middle">{{ order.status }}</td>
                                <td class="align-middle">{{ order.gallaryName }}</td>-->
                                <td class="align-middle text-left">{{ order.email }}</td>
                            <!--<td class="align-middle">{{ order.description }}</td>-->
                                <td class="align-middle">{{ order.animal_type }}</td>
                                <td class="align-middle">{{ order.came_from }}</td>                        
                                <td class="align-middle">{{ order.tile_size }}</td>
                            <!--<td class="align-middle">{{ order.animalName }}</td>
                                <td class="align-middle">{{ order.animalNameFont }}</td>
                                <td class="align-middle">{{ order.animalDates }}</td>
                                <td class="align-middle">{{ order.animalDatesFont }}</td>
                                <td class="align-middle">{{ order.animalText }}</td>
                                <td class="align-middle">{{ order.animalTextFont }}</td>
                                <td class="align-middle">{{ order.layout }}</td>
                                <td class="align-middle">{{ order.dateComplition }}</td>
                                <td class="align-middle">{{ order.ornaments }}</td>-->
                                <td class="align-middle">
                                <span class="text-success" v-if="order.using_pix_in_portfolio"> YES </span>
                                <span class="text-danger" v-else>NO</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </transition>
            </div>
    
        <!--CONFIRMATION MESSAGES -->
            <app-confirmation @showDialogue="closeDialogue" :successMessage="successMessage" :errorMessage="errorMessage" v-if="showingMessageModal" />
    </div>
</template>

<script>
    import axios from 'axios'
    import lightbox from '@/components/Helpers/lightBox.vue'
    import pageHeader from '@/components/Helpers/PageHeader.vue'
    import conDialog from '@/components/Helpers/ConfirmationDialogue.vue'
        export default {
                data(){
                    return {
                            apiURL: process.env.APP_API,

                            departmentName: "Orders Managing Area",
                            menuItem: 'Orders',

                            showingMessageModal: false,
                            CurrentOrderView: false,
                            tableView: true,
                            ordersOpenTotal: null,
                            ordersAllTotal: null,
                            errorMessage: null,
                            successMessage: null,
                            orders: [],
                            ordersOpen: [],
                            orderCurrent: [],
                            uploadedImagesAdminPreview: [],
                            currentOrder: {
                                id: null,
                                newstatus: null
                            }
                        }
                    },
                components: {
                        'app-lbox' : lightbox,
                        'app-confirmation' : conDialog,
                        'app-page-header' : pageHeader
                    },
                mounted(){
                        this.getAllOrders()
                        this.getOpenOrders()
                    },
                methods: {
                    closeDialogue(status){
                        this.showingMessageModal = status
                        },
                    getAllOrders(){
                            axios.get(this.apiURL + '?action=readall')
                            .then((res) => {
                                if(res.data.error){
                                    app.errorMessage = res.data.message
                                } else {
                                    this.orders = res.data.orders
                                    this.ordersAllTotal = this.orders.length
                                }
                            })
                        },
                    getOpenOrders(){
                            axios.get(this.apiURL+'?action=readopen')
                            .then((res) => {
                                if(res.data.error){
                                    app.errorMessage = res.data.message
                                } else {
                                    this.ordersOpen = res.data.orders
                                    this.ordersOpenTotal = this.ordersOpen.length
                                }
                            })
                        },
                    getCurrentOrder(id){
                            axios.get(this.apiURL+'?action=readcurrent', {
                                params: {
                                id: id
                                }
                            })
                            .then((res) => {
                                if(res.data.error){
                                    this.errorMessage = res.data

                                } else {
                                    this.orderCurrent = res.data.order
                                }
                            })
                            this.CurrentOrderView = true
                        },
                    changeStatus(e, id){
                            this.currentOrder.newstatus = e.target.value
                            this.currentOrder.id = id

                            // console.log('Принят статус: ', this.currentOrder.newstatus)
                            // console.log('Принято id: ', this.currentOrder.id)

                            const formData = new FormData()

                            formData.append('orderID', this.currentOrder.id)
                            formData.append('orderNewStatus', this.currentOrder.newstatus)

                           axios.post(this.apiURL+'?action=updatestatus', formData)
                                .then((res) => {
                                    if(res.data.error){
                                        this.errorMessage = res.data.message
                                        this.showingMessageModal = true
                                    } else {
                                        this.successMessage = res.data.message
                                        this.showingMessageModal = true
                                            setTimeout(()=> {
                                                this.showingMessageModal = false
                                            }, 2000)
                                        this.getAllOrders()
                                        this.getOpenOrders()
                                    }
                                })
                        },
                    imgBuilder(gallaryName, imgString){
                            var imgPath = '/static/img/uploads/' + gallaryName + '/'
                                console.log(imgPath)
                                
                            // Режем имена файлов
                            var images = imgString.split(',')

                            // РАБОТАЕМ с lightbox:
                                /**
                                 * 1. Вытаскивает из базы путь и имя файла
                                 * 2. Склеивает путь и имя
                                 * 3. Запихивает в массив объектов и отдаёт компоненту lightbox
                                 */
                                var lightBoxImages = new Array()

                                images.forEach(element => {
                                var image = imgPath
                                    image += element
                
                                    lightBoxImages.push({'src' : image, 'title': element })
                                });  
                                // console.log('А вот JSON архив: ', lightBoxImages)
                                return lightBoxImages  

                            // РАБОТАЕМ напрямую на страницу: 
                                /** 
                                 * 1. ВЫТАСКИВАЕТ из базы путь и имя файла
                                 * 2. Склеивает их и строит строку полного img элемента
                                 * 3. Запихивает все img в массив и выдаёт на странице
                                 */
                                //
                                // var readyImage = new Array()
                                // for(var i = 0; i < images.length; i++) {
                                // var image = '<img class="img-fluid" src="'
                                //     image += gallaryName
                                //     image += images[i]
                                //     image += '">'  
                                //     readyImage.push(image) 
                                // }
                                // console.log('Вот такой мы получаем массив: ', readyImage) 
                                // return readyImage 
                                // --------------------------------------------------------                                          
                        },
                    deleteOrder(id){
                            var del = confirm('Are you serious?')
                            if(del){
                                const formData = new FormData()
                                formData.append('id', id)

                                axios.post(this.apiURL + '?action=delete', formData)
                                .then((res) => {
                                    if(res.data.error){
                                        this.errorMessage = res.data.message
                                        this.showingMessageModal = true
                                    } else {
                                        this.successMessage = res.data.message
                                        this.showingMessageModal = true
                                            setTimeout(()=> {
                                                this.showingMessageModal = false
                                            }, 2000)
                                        this.getAllOrders()
                                        this.getOpenOrders()
                                    }
                                })
                            }
                        },
                    editOrder(id){
                            this.$router.push({name: 'orderEdit', params: { id: id }})
                        }
                }
            }
</script>

<style>
/* MODAL MESSAGE */    
    .modalMessageContent {
        min-height: 100px;
        padding: 10px;
    }
    .modalMessageContainer {
        width: 500px;
        background: #ffffff;
        margin: auto;
        margin-top: 150px;
        border-radius: 8px;
    }
    .modalMessageHeading {
        padding: 9px;
        color: #ffffff;
    }
    .modMessageBackground {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom:0;
        background: rgba(0,0,0,0.4); z-index:99;
    }

/* ANIMATION START*/
    .fade-enter {
        opacity: 0;
    }
    .fade-enter-active {
        transition: 1s;
    }
    /* .fade-leave {} */
    .fade-leave-active {
        transition: 1s;
        opacity: 0;
    }
/* ANIMATION END*/
</style>





// WEBPACK FOOTER //
// src/components/Order/Orders.vue